import React from "react";
import { NavLink } from "react-router-dom";
import { Input, Select } from "src/_components/common/_forms";
import InfiniteScroll from "react-infinite-scroll-component";
import SelectNew from "react-select";
import DynamicForm from "./DynamicForm";
// import DayPicker from 'react-day-picker';
import DayPickerInput from "react-day-picker/DayPickerInput";

import MomentLocaleUtils, {
  formatDate,
  parseDate
} from "react-day-picker/moment";
import Loader from "src/_components/common/Loader";
// import * as SelectNew from 'react-select';

const EditUserProfilePageTemp = props => {
  // console.log('-------------------',props.name,'-----------------------')

  const accessList = [
    { label: "User Access", value: "User Access", id: 1, },
    { label: "Approver Access", value: "Approver Access", id: 2, },

  ];
  const {
    formData,
    fetchMoreData,
    hasMore,
    openDelegate,
    searchUser,
    search,
    error,
    state,
    count,
    handleChange,
    staticHandle,
    isEdit,
    submitUpdateHandle,
    dummuyValue,
    travelClass,
    userList,
    handleSelectChange,
    chooseDelegate,
    delegatedItem,
    delegatedView,
    handleChangeDelegate,

    serviceName,
    accessTypeName,
    handleStatusChange,
    removeDelegateHandler,
    inviteHandler,
    testUserHandler,
    handleTravelSelector,
    dayChangeHandler,
    imageSelectedHandler,
    handleSelectedOption
  } = props;

  const {
    delegatedUser,
    activeStatus,
    id,
    isTestUser,
    invite,
    removedDelegate,
    allTravelAllowance,
    allTravelClass,
    selectedTravelClass,
    selectedTravelAllowance,
    selectedTravelWorkflow,
    allTravelWorkflow,
    isVerifiedInvitation,
    allDelegatedUsers,
    profileImage,
    service,
    serviceList,
    isLoading,
  } = props.state;
  const path = `url(${profileImage})`;
  const profImg = {
    backgroundImage: path
  };
  let travelClassOptions = [],
    travelAllowanceOptions = [];

  // * Create options for travel class
  if (allTravelClass) {
    // console.log(allTravelClass);
    travelClassOptions = allTravelClass.map(item => {
      return {
        value: item.id,
        label: item.className
      };
    });
  }

  // * Create options for travel allowance

  if (allTravelAllowance) {
    travelAllowanceOptions = allTravelAllowance.map(item => {
      return {
        value: item.id,
        label: item.configurationName
      };
    });
  }

  const getAccessListValues = (accessType) => {
    if (accessType.length) {
      var accessValues = accessList.filter(item => {
        return accessType.includes(item.value);
      });
    }
    // console.log(accessType)
    return accessValues;
  }


  const getServiceListValue = service => {
    if (serviceList) {
      let mappedServiceList = serviceList.map(item => {
        return {
          value: item.id,
          label: item.serviceModuleName
        }
      })
      var res = mappedServiceList.filter(item => service.includes(item.value));
    }
    return res
  };
  let serviceOptions = [];
  serviceList && serviceList.forEach((service) => {
    serviceOptions.push({ label: service.serviceModuleName, value: service.id })
  });
  // const options = [
  //   { value: 'chocolate', label: 'Chocolate' },
  //   { value: 'strawberry', label: 'Strawberry' },
  //   { value: 'vanilla', label: 'Vanilla' }
  // ];
  const future = {
    after: new Date(2018, 0, 1),
  }
  return (
    <div>
      <div className="inner-header">
        <div className="shape-header">
          <div className="left">A</div>
          <div className="right">
            {isEdit === false ? (
              <h6 className="heading">Add User</h6>
            ) : (
                <h6 className="heading">Edit User</h6>
              )}
            <p className="text">Edit User Details.</p>
          </div>
        </div>
      </div>
      <div className="p-padding">
        {(state.isLoading) ?
          <div className="form-holder">
            <Loader />
          </div>
          :
          <div className="form-holder mb-3 zoomIn animated">
            <div className="row">
              <div className="col-xl-6 offset-xl-3 top-image">
                <div className="user-profile w-200">
                  <div className="img" style={profImg}>
                    {/* <i className="material-icons">
                    person
                      </i> */}
                    <div className="upload">
                      <span>Edit</span>
                      <input
                        type="file"
                        placeholder="Upload"
                        onChange={imageSelectedHandler}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group custom labelup mt-5">
                  <label>Travel Class</label>
                  {allTravelClass && (
                    <Select
                      disabled={true}
                      placeholder={
                        selectedTravelClass ? selectedTravelClass : "Select Rule"
                      }
                      keyName={"className"}
                      options={allTravelClass}
                      controlFunc={e => handleTravelSelector(e, "travelClass")}
                    // error={error.message("travelClass", state.selectedTravelClass, "")}
                    />
                  )}
                </div>
                <div className="form-group custom labelup">
                  <label>Travel Workflow </label>
                  {allTravelWorkflow && (
                    <Select
                      disabled={true}
                      placeholder={
                        selectedTravelWorkflow
                          ? selectedTravelWorkflow
                          : "Select Workflow"
                      }
                      keyName={"workflowName"}
                      options={allTravelWorkflow}
                      controlFunc={e => handleTravelSelector(e, "travelWorkflow")}
                    // error={error.message("travelWorkflow", state.selectedTravelWorkflow, "")}
                    />
                  )}
                </div>
                <div className="form-group custom labelup">
                  <label>Travel Allowance</label>
                  {allTravelAllowance && (
                    <Select
                      disabled={true}
                      placeholder={
                        selectedTravelAllowance
                          ? selectedTravelAllowance
                          : "Select Travel Allowance"
                      }
                      keyName={"configurationName"}
                      options={allTravelAllowance}
                      controlFunc={e =>
                        handleTravelSelector(e, "travelAllowance")
                      }
                    // error={error.message("travelAllowance", state.selectedTravelAllowance, "")}
                    />
                  )}
                </div>

                {/* <div className="form-group custom">
                <SelectNew
                  placeholder={localStorage.getItem('groupName') || ''}
                  isDisabled={true}
                />
              </div> */}
                {/* <div className="form-group custom">
                <Input
                  label="Name"
                  type="text"
                  name="fullName"
                  value={state.fullName}
                  error={error.message("fullName", state.fullName, "")}
                  controlFunc={e => staticHandle(e)}
                />
              </div> */}
                <div className="form-group custom">
                  <Input
                    label="Email"
                    type="email"
                    name="email"
                    value={state.email}
                    error={error.message("email", state.email, "required|email")}
                    controlFunc={e => staticHandle(e)}
                  />
                </div>
                <DynamicForm
                  {...props}
                  validator={props.validator}
                  policyForm={props.expenseForm}
                  onClickHandler={props.onClickHandler}
                  onChangeHandler={props.onChangeHandler}
                  onDatePickerHandler={props.onDatePickerHandler}
                  onCheckboxHandler={props.onCheckboxHandler}
                  onIntegerHandler={props.onIntegerHandler}
                  userPermission={props.userPermission}
                  onConnectedListkHandler={props.onConnectedListkHandler}
                />
              </div>
            </div>
            <div className={(allDelegatedUsers.length !== 0) ? "delegate-switch" : "delegate-switch d-none"}>
              <h5 className="sub-heading mt-5">Delegate</h5>
              <div className="delegate">
                <div className="names">
                  <div className="search-custom">
                    <input
                      type="text"
                      name="searchUser"
                      onChange={searchUser}
                      className="form-control"
                      placeholder="Search User"
                    />
                    <span>
                      <i className="material-icons">search</i>
                    </span>
                  </div>

                  <div className="scroll">
                    <ul>
                      {userList &&
                        userList.map((item, key) => {
                          // console.log(item)
                          return (
                            <li
                              key={key}
                              className={
                                delegatedItem === item.id ? "active" : ""
                              }
                              onClick={() => chooseDelegate(item)}
                            >
                              <div className="shape-name">
                                <div className="left user-icon">
                                  <i className="material-icons">
                                    person
                      </i>
                                </div>
                                <div className="right">
                                  {/* !! Will be used once the fieldData gets fixed */}
                                  {/* <h6 className="heading">{item.fieldData[0].fieldValue + item.fieldData[1].fieldValue}</h6> */}
                                  <h6 className="heading">{item.email}</h6>
                                </div>
                              </div>
                            </li>
                          );
                        })
                      }
                    </ul>
                  </div>
                </div>
                <InfiniteScroll className="detail">
                  <div className="">
                    <h6 className="sub-heading light">Delegated</h6>
                    <div className="scroll">
                      {allDelegatedUsers &&
                        allDelegatedUsers.map((item, idx) => {
                          return (
                            <div className="all-detail" key={item.delegatedUserId + idx}>
                              <div className="shape-name lg">
                                <div className="left user-icon"><i className="material-icons">
                                  person
                                </i></div>
                                <div className="right m-less">
                                  <button
                                    onClick={() => removeDelegateHandler(item)}
                                    className="btn btn-nothing fs-20 float-right"
                                  >
                                    &times;
                              </button>
                                  <h6 className="heading">{item.email}</h6>
                                  <h6 className="heading">{item.fullName}</h6>
                                  {/* <p className="text">Travel Manager</p> */}
                                </div>
                              </div>
                              <form className="b-1">
                                <div className="row">
                                  {/* <div className="col-md-6">
                                <div className="form-group custom labelup white">
                                  <label>Access Type</label>
                                  {accessList && (
                                    <Select
                                      placeholder={
                                        item
                                          ? getAccessListValue(item)
                                          : accessTypeName
                                      }
                                      keyName={"value"}
                                      options={accessList}
                                      controlFunc={e =>
                                        props.changeData(e, "accessType", item)
                                      }
                                      error={error.message(
                                        "AccessType",
                                        item.accessType,
                                        "required"
                                      )}
                                    />
                                  )}
                                </div>
                              </div> */}
                                  <div className="col-md-6">
                                    <div className="form-group custom labelup white textarea">
                                      <label>Access Type</label>
                                      {
                                        accessList && (
                                          <SelectNew
                                            // value={{value: '1', label: 'somethung'}}
                                            value={accessList ? getAccessListValues(item.accessType) : ""}
                                            name="accessType"
                                            isMulti
                                            isSearchable
                                            options={accessList}
                                            onChange={(e) => props.changeData(e, "accessType", item)}
                                            required
                                          />
                                        )}
                                    </div>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="form-group custom labelup white textarea">
                                      <label>Service</label>
                                      {
                                        serviceOptions && (
                                          <SelectNew
                                            name="service"
                                            isMulti
                                            isSearchable
                                            //value={service}
                                            value={item.serviceModule ? getServiceListValue(item.serviceModule) : ''}

                                            options={serviceOptions}
                                            onChange={(e) => props.changeData(e, "service", item)}
                                            required
                                          />
                                        )}
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group custom labelup">
                                      <label>Start date</label>
                                      <DayPickerInput
                                        dayPickerProps={{
                                          disabledDays: {
                                            before: new Date(),
                                          },
                                        }}
                                        selectedDays={item.startDate}
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        value={
                                          item.startDate
                                            ? `${formatDate(
                                              new Date(item.startDate),
                                              "LL",
                                              "it"
                                            )}`
                                            : ""
                                        }
                                        placeholder="DD MM YYYY"
                                        onDayChange={day =>
                                          dayChangeHandler(day, "startDate", item)
                                        }
                                        format="DD-MM-YYYY"
                                      />
                                    </div>

                                    {/* </div> */}
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group custom labelup">
                                      <label>End date</label>
                                      <DayPickerInput
                                        dayPickerProps={{
                                          disabledDays: {
                                            before: (item.startDate) ? new Date(item.startDate) : new Date(),
                                          },
                                        }}
                                        selectedDays={item.endDate}
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        value={
                                          item.endDate
                                            ? `${formatDate(
                                              new Date(item.endDate),
                                              "LL",
                                              "it"
                                            )}`
                                            : ""
                                        }
                                        placeholder="DD MM YYYY"
                                        onDayChange={day =>
                                          dayChangeHandler(day, "endDate", item)
                                        }
                                        format="DD-MM-YYYY"
                                      />
                                    </div>
                                  </div>

                                </div>
                              </form>
                            </div>
                          );
                        })}
                      {/* @nd One for test */}

                      {/* End of second one */}
                    </div>
                  </div>
                </InfiniteScroll>
                <div className="clearfix" />
              </div>
            </div>
            <div className="btn-group-margin mt-4">
              <div className="row">
                <div className="col-xl-6 offset-xl-3 text-center">
                  <button
                  className={(allDelegatedUsers.length === 0) ? "btn":"btn d-none"}
                  id="delegate-btn"
                  onClick={e => props.openDelegate()}
                >
                  Add Delegate
                </button>
                  {isEdit === false ? (
                    <button
                      onClick={props.onSubmitHandler}
                      className="btn"
                    >
                      Save
              </button>
                  ) : (
                      <button
                        onClick={submitUpdateHandle}
                        className="btn"
                      >
                        Update
              </button>
                    )}
                  <NavLink to="/my-account/profile">
                    {" "}
                    <button className="btn">
                      Cancel
              </button>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
      }
      </div>
    </div>
  );
};
export default EditUserProfilePageTemp;
